<template>
    <div class="agent-page">
        <!-- 页面头部 -->
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ projectInfo.projectType }}--招标项目编号：{{
                    projectInfo.projectNumber }}　招标项目名称：{{
                        projectInfo.projectName }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">录入评委信息</h2>
            </div>
            <div style="display: flex; gap: 12px;">
                <el-button type="primary" icon="el-icon-plus" @click="handleFormCommittee">组建评标委员会</el-button>
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
            </div>
        </div>
        
        <!-- 数据表格 -->
        <div class="table-section">
            <el-table :data="tableData" v-loading="loading" border style="width: 100%" class="data-table">
                <el-table-column prop="no" label="NO." width="60" align="center" />
                <el-table-column prop="reviewTime" label="评审时间" show-overflow-tooltip />
                <el-table-column label="包含标段" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-for="(sectionName, index) in scope.row.includingSections" :key="index">
                            {{ sectionName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="详细信息" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleViewDetail(scope.row)" class="action-btn">
                            查看详情
                        </el-button>
                        <el-button type="text" size="small" @click="handleMemberManagement(scope.row)"
                            class="action-btn">
                            成员管理
                        </el-button>
                        <el-button type="text" size="small" @click="handleExtractn(scope.row)"
                            v-if="scope.row.extractType != 1">
                            专家抽取
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-section">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" class="pagination" />
        </div>

        <!-- 组建评委会管理弹窗 -->
        <el-dialog title="组建评委会管理" :append-to-body="true" :visible.sync="committeeDialogVisible" width="50%"
            :before-close="handleCloseCommitteeDialog"  class="committee-dialog" >
            <el-form :model="committeeForm" :rules="committeeRules" ref="committeeForm" label-width="250px"
                class="committee-form">
                <!-- 标段名称 -->
                <el-form-item label="标段名称:" prop="sectionName" required>
                    <el-select v-model="committeeForm.sectionName" placeholder="请选择标段名称" style="width: 100%;">
                        <el-option v-for="item in sectionOptions" :key="item.bidSectionCode"
                            :label="item.bidSectionName" :value="item.bidSectionCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- 评审开始时间 -->
                <el-form-item label="评审开始时间:" prop="reviewStartTime" required>
                    <app-date-picker v-model="committeeForm.reviewStartTime" type="datetime" placeholder="选择日期时间"
                        style="width: 30%;">
                    </app-date-picker>
                </el-form-item>
                <!-- 评委会人数 -->
                <el-form-item label="评委会人数:" prop="committeeCount" required>
                    <el-input-number v-model="committeeForm.committeeCount" :min="0" :max="20" style="width: 150px;">
                    </el-input-number>
                </el-form-item>
                <!-- 评标室 -->
                <el-form-item label="评标室:" prop="evaluationRoom" required>
                    <el-input v-model="committeeForm.evaluationRoom" placeholder="请输入评标室" />
                </el-form-item>
                <!-- 专家抽取方式 -->
                <el-form-item label="专家抽取方式:" prop="extractType" required>
                    <el-radio v-model="committeeForm.extractType" :label="1">自行组建</el-radio>
                    <el-radio v-model="committeeForm.extractType" :label="2">平台抽取</el-radio>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleSaveCommittee" :loading="saving">保存</el-button>
            </div>
        </el-dialog>

        <!-- 成员管理弹窗 -->
        <el-dialog title="成员管理" :visible.sync="memberDialogVisible" width="80%" :before-close="handleCloseMemberDialog"
            class="member-dialog"   :append-to-body="true" >
            <!-- 添加成员按钮 -->
            <div class="member-header">
                <el-button type="success" icon="el-icon-plus" @click="handleAddMember" v-if="extractType==1">添加</el-button>
            </div>
            <!-- 成员列表表格 -->
            <el-table :data="memberList" border style="width: 100%" class="member-table">
                <el-table-column prop="index" label="#" width="60" align="center">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="realName" label="专家姓名" show-overflow-tooltip />
                <el-table-column prop="idCard" label="身份证号" show-overflow-tooltip />
                <el-table-column prop="company" label="工作单位" show-overflow-tooltip />
                <el-table-column prop="phone" label="手机" show-overflow-tooltip />
                <el-table-column prop="identity" label="专家身份" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.identity == '0' ? '专家' : '甲方代表' }}
                    </template>
                </el-table-column>
                <el-table-column prop="professionalTitle" label="职称" show-overflow-tooltip />
                <!-- <el-table-column prop="region" label="地区" show-overflow-tooltip /> -->
                <el-table-column label="操作" align="center" width="220"  v-if="extractType==1">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleEditMember(scope.row)" class="action-btn">
                            编辑
                        </el-button>
                        <el-button type="text" size="small" @click="handleDeleteMember(scope.row)"
                            class="action-btn delete-btn">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div slot="footer" class="dialog-footer">
                <el-button @click="memberDialogVisible = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 添加/编辑成员弹窗 -->
        <el-dialog :title="memberFormTitle" :visible.sync="memberFormDialogVisible" width="50%"
            :before-close="handleCloseMemberFormDialog"  class="member-form-dialog"  :append-to-body="true">

            <el-form :model="memberForm" :rules="memberRules" ref="memberForm" label-width="250px" class="member-form">
                <!-- 专家姓名 -->
                <el-form-item label="专家姓名:" prop="realName" required>
                    <el-input v-model="memberForm.realName" placeholder="请输入专家姓名" />
                </el-form-item>

                <!-- 身份证号 -->
                <el-form-item label="身份证号/专家证书编号" prop="idCard" required>
                    <el-input v-model="memberForm.idCard" placeholder="请输入身份证号" />
                </el-form-item>

                <!-- 工作单位 -->
                <el-form-item label="工作单位:" prop="company">
                    <el-input v-model="memberForm.company" placeholder="请输入工作单位" />
                </el-form-item>

                <!-- 手机 -->
                <el-form-item label="手机:" prop="phone" required>
                    <el-input v-model="memberForm.phone" placeholder="请输入手机号" />
                </el-form-item>

                <!-- 专家身份 -->
                <el-form-item label="专家身份:" prop="identity" required>
                    <el-select v-model="memberForm.identity" placeholder="请选择专家身份" style="width: 100%;">
                        <el-option v-for="item in identityOptions" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <!-- 职称 -->
                <el-form-item label="职称:" prop="professionalTitle">
                    <el-input v-model="memberForm.professionalTitle" placeholder="请输入职称" />
                </el-form-item>

                <!-- 地区 -->
                <el-form-item label="地区:" prop="region" required>
                    <el-cascader ref="regionCascader" v-model="memberForm.region" placeholder="请选择地区"
                        style="width: 100%;" :props="regionCascaderProps" @change="handleRegionChange">
                    </el-cascader>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="memberFormDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleSaveMember" :loading="memberSaving">保存</el-button>
            </div>
        </el-dialog>

        <!-- 详情弹窗 -->
        <el-dialog title="项目详情" :visible.sync="detailDialogVisible" width="50%" :before-close="handleCloseDetailDialog"
           class="detail-dialog"  :append-to-body="true">

            <div class="detail-content" v-if="currentDetailData">
                <div class="detail-item">
                    <span class="detail-label">标段名称：</span>
                    <span class="detail-value">
                        <div v-for="(section, index) in (currentDetailData.bidSectionList || [])" :key="index">
                            {{ section.bidSectionName }}
                        </div>
                    </span>
                </div>

                <div class="detail-item">
                    <span class="detail-label">项目名称：</span>
                    <span class="detail-value">{{ projectInfo.projectName }}</span>
                </div>

                <div class="detail-item">
                    <span class="detail-label">评审开始时间：</span>
                    <span class="detail-value">{{ currentDetailData.bidEvaluationStartTime }}</span>
                </div>

                <div class="detail-item">
                    <span class="detail-label">评审会总人数：</span>
                    <span class="detail-value">{{ currentDetailData.expertsCount }}人</span>
                </div>

                <div class="detail-item">
                    <span class="detail-label">评标室：</span>
                    <span class="detail-value">{{ currentDetailData.bidEvaluationRoom }}</span>
                </div>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCloseDetailDialog">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    initBidEvaluationCommittee,
    getBidEvaluationCommitteeList,
    addBidEvaluationCommittee,
    getBidEvaluationCommitteeDetail,
    getBidEvaluationCommitteeExpertList,
    addBidEvaluationCommitteeExpert,
    getBidEvaluationCommitteeExpertDetail,
    deleteBidEvaluationCommitteeExpert
} from '@/api/bidEvaluationCommittee/api'
import { getProjectDetail } from '@/api/agent/api'
import { timeUtils, getProjectTypeName } from '@/utils/base'
import RegionUtils from '@/utils/regionUtils'
export default {
    name: 'JudgeInfoEntry',
    data() {
        return {
            // 评委会id
            bidEvaluationCommitteeId: '',
            // 项目信息
            projectInfo: {
                projectNumber: '',
                projectName: '',
                projectType: ''
            },
            extractType:0,//专家抽取方式：1自行组建，2平台抽取
            projectCode: this.$route.query.projectCode,//项目编号
            projectId: this.$route.query.projectId,//项目id
            loading: false,//列表加载状态
            saving: false,//保存状态
            committeeDialogVisible: false,
            // 成员管理相关
            memberDialogVisible: false,
            memberFormDialogVisible: false,
            memberSaving: false,//成员保存状态
            memberFormTitle: '添加成员',
            currentEditMember: null,//当前正在编辑的成员
            // 详情弹窗相关 
            detailDialogVisible: false,
            currentDetailData: null,
            tableData: [],//表单数据

            identityOptions: [
                { label: '专家', value: 0 },
                { label: '甲方代表', value: 1 }
            ],
            //
            pagination: {
                currentPage: 1,//当前页
                pageSize: 10,//每页显示条数
                total: 0//总条数
            },
            // 组建评委会表单数据
            committeeForm: {
                sectionName: '',
                reviewStartTime: '',
                committeeCount: 0,
                evaluationRoom: '',
                extractType: 1,

            },
            // 表单验证规则
            committeeRules: {
                sectionName: [
                    { required: true, message: '请选择标段名称', trigger: 'change' }
                ],
                reviewStartTime: [
                    { required: true, message: '请选择评审开始时间', trigger: 'change' }
                ],
                committeeCount: [
                    { required: true, message: '请输入评委会人数', trigger: 'blur' }
                ],
                evaluationRoom: [
                    { required: true, message: '请输入评标室', trigger: 'blur' }
                ],
                extractType: [
                    { required: true, message: '请选择专家抽取方式', trigger: 'change' }
                ]
            },
            // 标段选项
            sectionOptions: [],
            // 成员列表数据
            memberList: [
            ],
            // 成员表单数据
            memberForm: {
                realName: '',
                idCard: '',
                company: '',
                phone: '',
                identity: 0,
                professionalTitle: '',
                region: [],
                province: '',
                provinceCode: '',
                city: '',
                cityCode: '',
                county: '',
                countyCode: '',
                  status:1,
            },
            // 成员表单验证规则
            memberRules: {
                realName: [
                    { required: true, message: '请输入专家姓名', trigger: 'blur' }
                ],
                idCard: [
                    { required: true, message: '请输入身份证号', trigger: 'blur' },
                    { pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '身份证号格式不正确', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
                ],
                identity: [
                    { required: true, message: '请选择专家身份', trigger: 'change' }
                ],
                region: [
                    { required: true, message: '请选择地区', trigger: 'change' }
                ]
            }
        }
    },
    computed: {
        // 地区级联选择器配置
        regionCascaderProps() {
            return RegionUtils.getCascaderProps()
        }
    },
    mounted() {
        this.loadData()
        // 初始化表单地区字段
        RegionUtils.initRegionFields(this.memberForm)
    },
    methods: {
        // 地区选择变化时，映射省/市/县名称和编号
        async handleRegionChange(value) {
            await RegionUtils.handleRegionChange(
                value,
                this.$refs.regionCascader,
                this.memberForm,
                { enableDebug: true },
                this
            )
        },
        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },
        // 加载数据
        loadData() {
            this.initBidEvaluationCommittee()
            this.getProjectDetail()
        },
        // 获取项目详情
        getProjectDetail() {
            getProjectDetail({ projectCode: this.projectCode }).then(res => {
                if (res.code == 200) {
                    this.projectInfo.projectNumber = res.data.projectCode
                    this.projectInfo.projectName = res.data.projectName
                    this.projectInfo.projectType = getProjectTypeName(res.data.projectType)
                } else {
                    this.$message.error(res.msg || '获取项目详情失败')
                }
            }).catch(error => {
                console.error('获取项目详情失败:', error)
                this.$message.error('获取项目详情失败')
            })
        },
        //初始化页面数据接口
        initBidEvaluationCommittee() {
            this.loading = true
            initBidEvaluationCommittee(this.projectCode).then(res => {
                if (res.code === 200) {
                    this.loading = false
                    this.sectionOptions = res.data.bidSectionList
                    this.getBidEvaluationCommitteeList()
                } else {
                    this.loading = false
                    this.$message.error(res.msg || '获取数据失败')
                }
            })
        },
        // 评委会列表
        getBidEvaluationCommitteeList() {
            let params = {
                projectCode: this.projectCode,
                pageNum: this.pagination.currentPage,
                pageSize: this.pagination.pageSize
            }
            getBidEvaluationCommitteeList(params).then(res => {
                if (res.code === 200) {
                    this.pagination.currentPage = res.data.current
                    this.pagination.total = res.data.total
                    this.pagination.pageSize = res.data.size
                    this.tableData = (res.data.records || []).map((item, index) => {
                        return {

                            id: item.id,
                            no: (this.pagination.currentPage - 1) * this.pagination.pageSize + index + 1,
                            reviewTime: item.bidEvaluationStartTime,
                            includingSections: (item.bidSectionList || []).map(section => section.bidSectionName),
                            extractType: item.extractType,
                        }
                    })
                } else {
                    this.$message.error(res.msg || '获取数据失败')
                }
            })
        },
        // 组建评标委员会
        handleFormCommittee() {
            this.committeeDialogVisible = true
        },
        // 保存组建评委会信息
        handleSaveCommittee() {
            this.$refs.committeeForm.validate((valid) => {
                if (valid) {
                    this.saving = true
                    this.saveBidEvaluationCommittee()
                } else {
                    this.$message.error('请完善必填信息')
                }
            })
        },
        // 保存保存评委会接口
        saveBidEvaluationCommittee() {
            // 构建标段列表数据
            let bidSectionList = []
            let sectionId = ''
            this.sectionOptions.forEach(item => {
                // 匹配当前选择的标段
                if (item.bidSectionCode == this.committeeForm.sectionName) {
                    sectionId = item.sectionId
                    bidSectionList.push({
                        bidSectionName: item.bidSectionName,
                        bidSectionReviewStartTime: timeUtils.formatTime(item.reviewStartTime),
                        bidSectionCommitteeCount: item.committeeCount,
                        bidSectionCode: item.bidSectionCode,
                        bidSectionRoom: item.evaluationRoom
                    })
                }
            })
            // 构建请求数据
            let data = {
                bidEvaluationRoom: this.committeeForm.evaluationRoom,
                bidEvaluationStartTime: timeUtils.formatTime(this.committeeForm.reviewStartTime),
                expertsCount: this.committeeForm.committeeCount,
                projectCode: this.projectCode,
                status: 1,
                bidSectionList: bidSectionList,
                sectionId: sectionId,
                extractType: this.committeeForm.extractType
            }
            // 调用API保存数据
            addBidEvaluationCommittee(data).then(res => {
                if (res.code === 200) {
                    this.saving = false
                    this.$message.success('保存成功')
                    this.committeeDialogVisible = false
                    this.resetCommitteeForm()
                    this.loadData()
                } else {
                    this.$message.error(res.msg || '保存失败')
                }
            }).catch(err => {
                this.saving = false  // 重置保存状态
                this.$message.error('请求异常，请稍后重试')
            })
        },
        // 重置组建评委会表单
        resetCommitteeForm() {
            this.committeeForm = {
                sectionName: '',
                reviewStartTime: '',
                committeeCount: 0,
                evaluationRoom: ''
            }
            if (this.$refs.committeeForm) {
                this.$refs.committeeForm.resetFields()
            }
        },
        // 查看详情
        handleViewDetail(row) {
            // 先获取评委会详情
            this.getCommitteeDetail(row.id);
            this.detailDialogVisible = true
        },
        //  获取评委会详情 接口
        getCommitteeDetail(id) {
            // 调用详情接口
            getBidEvaluationCommitteeDetail(id).then(res => {
                if (res.code === 200) {
                    // 处理详情数据
                    console.log('评委会详情:', res.data);
                    this.currentDetailData = res.data
                } else {
                    this.$message.error(res.msg || '获取详情失败');
                }
            });
        },
        // 关闭详情弹窗
        handleCloseDetailDialog() {
            this.detailDialogVisible = false
            this.currentDetailData = null
        },

        // 成员管理
        handleMemberManagement(row) {
            this.extractType = row.extractType;
            this.memberDialogVisible = true
            this.bidEvaluationCommitteeId = row.id
            this.getBidEvaluationCommitteeExpertList();
        },
        // 专家抽取
        handleExtractn(row) {
            console.log(row);
            
            this.$router.push({ path: '/agentHome/expertExtraction', query: { projectCode: this.projectCode,id:row.id } })
        },

        // 获取评委会专家列表接口
        getBidEvaluationCommitteeExpertList() {
            getBidEvaluationCommitteeExpertList(this.bidEvaluationCommitteeId).then(res => {
                if (res.code === 200) {
                    this.memberList = res.data
                } else {
                    this.$message.error(res.msg || '获取数据失败');
                }
            })
        },
        // 关闭成员管理弹窗
        handleCloseMemberDialog() {
            this.memberDialogVisible = false
        },

        // 添加成员
        handleAddMember() {
            this.memberFormTitle = '添加成员'
            this.currentEditMember = null
            this.resetMemberForm()
            this.memberFormDialogVisible = true
        },
        // 编辑成员
        handleEditMember(row) {
            this.memberFormTitle = '编辑成员'
            this.currentEditMember = row
            this.memberFormDialogVisible = true
            this.getBidEvaluationCommitteeExpertDetail(row.id)
        },
        // 获取获取评委会成员详情接口
        getBidEvaluationCommitteeExpertDetail(id) {
            getBidEvaluationCommitteeExpertDetail(id).then(res => {
                if (res.code === 200) {
                    const data = res.data
                    this.memberForm = {
                        ...data,
                        // 构建地区级联选择器需要的数组
                        region: [data.provinceCode, data.cityCode, data.countyCode].filter(Boolean)
                    }
                } else {
                    this.$message.error(res.msg || '获取数据失败');
                }
            })
        },
        // 删除成员
        handleDeleteMember(row) {
            this.$confirm('确定要删除该成员吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteBidEvaluationCommitteeExpert(row)
            }).catch(() => {
                this.$message.info('已取消删除')
            })
        },
        //删除成员
        deleteBidEvaluationCommitteeExpert(row) {
            deleteBidEvaluationCommitteeExpert(row.id).then(res => {
                if (res.code === 200) {
                    this.$message.success('删除成功');
                    this.memberFormDialogVisible = false;
                    this.loadData();
                    this.getBidEvaluationCommitteeExpertList()
                } else {
                    this.$message.error(res.msg || '删除失败');
                }
            });
        },
        // 保存成员
        handleSaveMember() {
            this.$refs.memberForm.validate((valid) => {
                if (valid) {
                    this.memberSaving = true
                    this.addBidEvaluationCommitteeExpert(this.memberForm)
                } else {
                    this.$message.error('请完善必填信息')
                }
            })
        },
        // 添加成员接口
        addBidEvaluationCommitteeExpert(data) {
            data.bidEvaluationCommitteeId = this.bidEvaluationCommitteeId
            addBidEvaluationCommitteeExpert(data).then(res => {
                if (res.code === 200) {
                    this.$message.success(res.msg || '添加成功');
                    this.memberFormDialogVisible = false;
                    this.memberSaving = false
                    this.resetMemberForm();
                    this.getBidEvaluationCommitteeExpertList();
                } else {
                    this.$message.error(res.msg || '添加失败');
                }
            }).catch(error => {
                this.$message.error('添加失败：' + (error.msg || '未知错误'));
            })
        },
        // 关闭成员表单弹窗
        handleCloseMemberFormDialog() {
            this.memberFormDialogVisible = false
            this.resetMemberForm()
        },

        // 重置成员表单
        resetMemberForm() {
            this.memberForm = {
                realName: '',
                idCard: '',
                company: '',
                phone: '',
                identity: 0,
                professionalTitle: '',
                region: [],
                province: '',
                provinceCode: '',
                city: '',
                cityCode: '',
                county: '',
                countyCode: '',
                status:1,

            }
            // 使用工具类初始化地区字段
            RegionUtils.initRegionFields(this.memberForm)
            if (this.$refs.memberForm) {
                this.$refs.memberForm.resetFields()
            }
        },
        // 关闭组建评委会弹窗
        handleCloseCommitteeDialog() {
            this.committeeDialogVisible = false
            this.resetCommitteeForm()
        },
        // 分页相关方法
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.loadData()
        },
        // 分页切换当前页码
        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.loadData()
        },
    },
}
</script>

<style lang="less" scoped>
// 引入极简灰度配色公共样式
@import '@/styles/minimal-gray-theme.less';

// 应用极简灰度主题
.agent-page {
    .apply-minimal-gray-theme();
}

// 页面头部（带按钮组）
.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 20px;

    .page-title {
        font-size: 16px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        position: relative;
        padding-left: 10px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }

        &:first-child::before {
            background: @primary-color;
        }
    }

    /deep/ .el-button {
        transition: all @transition-base ease;
        &:hover { transform: translateY(-1px); }
        &:active { transform: translateY(0); }
    }
}

.delete-btn {
    color: @error-color !important;
    &:hover { color: darken(@error-color, 10%) !important; }
}

// 组建评委会弹窗样式
.committee-dialog {
    .committee-form {
        .el-form-item {
            margin-bottom: 20px;

            .el-form-item__label {
                color: #333;
                font-weight: 500;
            }

            .el-select,
            .app-date-picker,
            .el-input-number {
                width: 100%;
            }

            .el-radio-group {
                .el-radio {
                    margin-right: 20px;

                    &.is-disabled {
                        .el-radio__label {
                            color: #c0c4cc;
                        }
                    }
                }
            }
        }
    }

    .dialog-footer {
        text-align: center;
        padding-top: 20px;
        border-top: 1px solid #eee;
    }
}

// 成员管理弹窗样式
.member-dialog {
    .member-header {
        margin-bottom: 20px;
        text-align: right;
    }

    .member-table {
        .action-btn {
            color: #409EFF;
            margin-right: 10px;
        }

        .delete-btn {
            color: #F56C6C !important;
        }
    }
}

// 成员表单弹窗样式
.member-form-dialog {
    .member-form {
        .el-form-item {
            margin-bottom: 20px;

            .el-form-item__label {
                color: #333;
                font-weight: 500;
            }

            .el-input,
            .el-select,
            .el-cascader {
                width: 100%;
            }
        }
    }

    .dialog-footer {
        text-align: center;
        padding-top: 20px;
        border-top: 1px solid #eee;
    }
}

// 详情弹窗样式
.detail-dialog {
    .detail-content {
        padding: 20px 0;

        .detail-item {
            display: flex;
            margin-bottom: 20px;
            align-items: flex-start;

            .detail-label {
                width: 120px;
                color: #666;
                font-weight: 500;
                flex-shrink: 0;
            }

            .detail-value {
                flex: 1;
                color: #333;
                word-break: break-all;
            }
        }
    }

    .dialog-footer {
        text-align: center;
        padding-top: 20px;
        border-top: 1px solid #eee;
    }
}
</style>
